import React from 'react';
var ListSponsors = function (props) {
    var sponsors = typeof props.sponsors === 'string'
        ? JSON.parse(props.sponsors)
        : props.sponsors;
    return sponsors.map(function (sponsor) { return (React.createElement("a", { href: sponsor.websiteUrl }, sponsor.logoUrl
        ? React.createElement("img", { src: sponsor.logoUrl, alt: sponsor.name })
        : React.createElement("span", null, sponsor.name))); });
};
export default ListSponsors;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/PageScoreboard/ListSponsors.tsx
// module id = 749
// module chunks = 0